import { useState, useEffect } from "react";

import API from "utils/api";
import { useUser } from "utils/hooks";
import { filtersToQueryParams } from "utils/misc";

export default function useForumThreads(filters = {}) {
  const [result, setResult] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    async function fetchForumThreads() {
      setLoading(true);
      const { response, data } = await API.fetchForumThreads(null, filtersToQueryParams(filters));

      if (response.ok) {
        setResult(data);
        setLoading(false);
      }
    }

    fetchForumThreads();
  }, [Object.values(filters).join("__"), setResult, setLoading]);

  return {
    loading,
    threads: result?.results ?? [],
    count: result?.count ?? 0,
    limit: result?.limit ?? 0,
    page: result?.page ?? 0,
  };
}
